module.exports = __webpack_public_path__ + "static/media/vegshammikebab.a764fea0.jpg";